import { AfterViewInit, Component, DoCheck, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrls } from '../../config/api-urls/api-urls';
import { MainService } from '../../provider/main.service';
declare var $: any;
@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, DoCheck {

  showLoginHeader: boolean = false;
  showLogo: boolean = false;
  showSidebar: boolean = false;
  selected: any;
  profileData: any;
  constructor(public mainService: MainService, private router: Router) { }

  ngOnInit() {
    this.mainService.loginData.subscribe((res: any) => {
      if (res) { this.profileData = res }
    });
    this.mainService.loginStatus.subscribe();
    if (localStorage.getItem('token')) {
      this.showSidebar = true;
      this.getProfile();
      this.mainService.profileData.subscribe((res) => {
        if (res) {
          this.profileData['profilePic'] = res;
        }

      })
    }
  }


  ngDoCheck() {
    this.mainService.loginStatus.subscribe();
    if (localStorage.getItem('token')) {
      this.showLoginHeader = true
    }
  }

  // get profile
  getProfile() {
    this.mainService.showSpinner()
    this.mainService.getApi(ApiUrls.profile, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.profileData = res.result
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
      }
    })
  }

  adminProfile() {
    this.router.navigate(['my-profile'])
  }

  head() {
    const logo = document.getElementById("logo");
    const logo1 = document.getElementById("logo1");
    
    if (logo !== null) {
      if (this.showLogo == false) {
        if ((logo.style.width === "45px")) {
          logo.style.display = "none";
          this.showLogo = true;
        }
      }
      else {
        logo1?.style?.display === "none";
        this.showLogo = false;
      }
    }
  }

  logOutModal() {
    $('#logoutModal').modal('show')
  }

  logout() {
    this.mainService.loginData.next('');
    this.mainService.loginStatus.next(false)
    localStorage.removeItem('token');
    $('#logoutModal').modal('hide')
    this.router.navigate(['login'])
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }
}
